import React from "react";

import Breadcrumbs from "../../../../components/Breadcrumbs";
import UsersTable from "./UsersTable";
import AddUserModal from "../../../../components/Administration/Users/AddUseModal";

const Users = () => {
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
     
        <UsersTable />
        <AddUserModal />
      </div>
    </div>
  );
};

export default Users;
